import React from 'react'

import Group from './Group/Group'

import messages from './messages'
import s from './LikesDislikes.scss'


type TagsProps = {
  likes: Review.LikeTag[]
  dislikes: Review.LikeTag[]
}

const LikesDislikes: React.FunctionComponent<TagsProps> = ({ likes, dislikes }) => {
  if (!likes.length && !dislikes.length) {
    return null
  }

  return (
    <div className={s.container}>
      {
        likes.length > 0 && (
          <Group
            className={s.group}
            emoji="👍"
            title={messages.likes}
            items={likes}
          />
        )
      }
      {
        dislikes.length > 0 && (
          <Group
            className={s.group}
            emoji="👎"
            title={messages.dislikes}
            items={dislikes}
          />
        )
      }
    </div>
  )
}

export default LikesDislikes
